import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import {Student} from '../student/student.model';
import {TylerMatTableDataSource} from '../angular-material/extended.class';
import {GeneralPreferences} from '../user-preferences/general-preferences.model';
import {StudentService} from '../student/student.service';
import {UserPreferencesService} from '../user-preferences/user-preferences.service';
import {StudentInformationComponent} from '../student-information/student-information.component';
import {LoginService} from '../../shared-modules/login/login.service';
import {DisciplineReferralStudent} from '../../classroom360/discipline-referral/discipline-referral-student.model';

@Component({
	selector: 'app-students-to-add-dialog',
	templateUrl: './students-to-add-dialog.component.html',
	styleUrls: ['./students-to-add-dialog.component.css']
})
export class StudentsToAddDialogComponent implements OnInit {

	// Injected Properties
	header = 'Mass Add Students';
	students: Student[] = [];

	// Local Properties
	tableData = new TylerMatTableDataSource();
	generalPreferences: GeneralPreferences;
	private _sort: MatSort;
	V10: boolean;

	// Class Functions
	constructor(
		@Inject(MAT_DIALOG_DATA) private data: any,
		private dialogBox: MatDialogRef<StudentsToAddDialogComponent>,
		private studentService: StudentService,
		private dialog: MatDialog,
		private userPreferencesService: UserPreferencesService,
		private loginService: LoginService
	) { }

	get sort(): MatSort {
		return this._sort;
	}

	@ViewChild(MatSort, { static: true }) set sort(value: MatSort) {
		this._sort = value;
		this.tableData.sort = value;
	}

	// Event Functions
	ngOnInit() {
		this.students = this.data.students;
		if (this.data.header) {
			this.header = this.data.header;
		}
		this.tableData.data = this.students;
		this.generalPreferences = this.userPreferencesService.generalPreferences;
		this.V10 = this.loginService.LoginSettings.V10;

		// Changing the data accessor so that sorting happens correctly
		this.tableData.sortingDataAccessor = (data: DisciplineReferralStudent, sortHeaderId: string): string|number => {
			switch (sortHeaderId) {
				case 'number':
					if (data.UnknownStudent) {
						return -1;
					} else if (data.NonStudent) {
						return -2;
					} else {
						return Number.parseInt(data.StudentNumber, 10);
					}
				case 'name': return data.formattedName(this.generalPreferences);
				default:
					if (data[sortHeaderId] instanceof Date) {
						return data[sortHeaderId].getTime();
					} else {
						return this.tableData.defaultSortingAccessor(data, sortHeaderId);
					}
			}
		};
	}

	close() {
		// PRE: the close button is clicked
		// POST: closes the dialog box
		this.dialogBox.close();
	}

	viewStudent(student: any) {
		// PRE: a student's name is clicked
		// POST: opens a sidenav for viewing student pages
		if (typeof student == 'number') {
			student = this.studentService.students.find(s => s.Id == student);
		}
		const dialog = this.dialog.open(StudentInformationComponent, {
			panelClass: 'tyl-mat-dialog',
			disableClose: true,
			height: '100%',
			position: {
				top: '0px',
				right: '0px'
			}
		});
		dialog.componentInstance.student = student;
		dialog.componentInstance.students = [student];
		dialog.componentInstance.initMenu();
	}

	// Methods
}
